import { Api } from "api";

export const getContractors = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/contragents/?hash_pw=${hash}`);
  return res.data;
};

export const addContractor = async (contractor: string, bin: string) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/contragent/?hash_pw=${hash}&contragent=${contractor}&bin=${bin}`);
  return res.data;
};

export const updateContractor = async (
  contractorId: number,
  new_contractor: string,
  isChanging: boolean,
  bin: string,
  new_status?: boolean
) => {
  const hash = localStorage.getItem("hash");
  const name = new_contractor !== undefined ? `&new_contragent=${new_contractor}` : "";
  const binNum = bin !== undefined ? `&bin=${bin}` : "";
  const status = new_status !== undefined ? `&status=${new_status}` : "";
  const change = isChanging !== undefined ? `&change_existing_contragent=${isChanging}` : "";
  const url = `/contragent/?hash_pw=${hash}&contragent_id=${contractorId}${name}${binNum}${status}${change}`;
  const res = await Api.put(url);
  return res.data;
};
